import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class SubjectService {

  static addSubject(data) {
    return axiosInstance.post(
      `${API_BASE_URL}${API_PATHS.addSubject}`,
      data,
      { headers: { "Content-Type": "application/json" } }
    );
  }

  static updateSubject(data) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editSubject}`;
    return axiosInstance
      .put(api, data)

  }

  static getSubject(item) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.getSubject}`;
    if (item?.id) {
      api = `${API_BASE_URL}${API_PATHS.getSubject}?id=${item?.id}`;
    }
    return axiosInstance
      .get(api, item)
  }

  static getClassSubject(item) {

    let api = `${API_BASE_URL}${API_PATHS.getclassSubjectsstudent}`;
    const params = new URLSearchParams();

    if (item?.id) params.append("id", item.id);
    if (item?.standardId) params.append("standardId", item.standardId);
    if (item?.sectionId) params.append("sectionId", item.sectionId);

    if ([...params].length > 0) {
      api += `?${params.toString()}`;
    }

    return axiosInstance.get(api);
  }

  static getExamSubject(item) {

    let api = `${API_BASE_URL}${API_PATHS.getexamSubjects}`;
    const params = new URLSearchParams();

    if (item?.id) params.append("id", item.id);
    if (item?.standardId) params.append("standardId", item.standardId);
    if (item?.sectionId) params.append("sectionId", item.sectionId);

    if ([...params].length > 0) {
      api += `?${params.toString()}`;
    }

    return axiosInstance.get(api);
  }




  static addClasssubject(data) {
    return axiosInstance.post(
      `${API_BASE_URL}${API_PATHS.addclassSubjects}`,
      data,
      { headers: { "Content-Type": "application/json" } }
    );
  }

  static updateClassSubject(data) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editclassSubjects}`;
    return axiosInstance
      .put(api, data)

  }

  static addExamSubject(data) {
    return axiosInstance.post(
      `${API_BASE_URL}${API_PATHS.addexamSubjects}`,
      data,
      { headers: { "Content-Type": "application/json" } }
    );
  }

  static updateExamSubject(data) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editexamSubjects}`;
    return axiosInstance
      .put(api, data)

  }


}

export default SubjectService;
